/** Public brand and contact only. Full legal identification remains pending. */
export const LEGAL_IDENTITY = Object.freeze({
  commercialName: 'Juris',
  email: 'chat.juris.es@gmail.com',
});
